import React, { Fragment } from 'react'
import HeadingRocket from '../heading-rocket'

const CompletePasswordResetSuccessView = () => (
  <Fragment>
    <HeadingRocket>Password Reset</HeadingRocket>

    <p>Your password has been updated successfully!</p>
  </Fragment>
)

export default CompletePasswordResetSuccessView



// WEBPACK FOOTER //
// ./src/complete-password-reset/success.jsx